var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'UIElement',
    'UILayoutSectionAnnotated',
    _vm.$style.LayoutSectionAnnotated,
    _vm.fullWidth && _vm.$style.fullWidth
  ]},[_c('div',{class:_vm.$style.Info},[_c('div',{class:_vm.$style.Info_content},[_c('Heading',{attrs:{"element":"h2"}},[_vm._v(_vm._s(_vm.title))]),(_vm.description || _vm.$slots.description)?_c('div',{class:_vm.$style.description},[_vm._t("description",function(){return [_vm._v(" "+_vm._s(_vm.description)+" ")]})],2):_vm._e()],1),_c('div',{class:_vm.$style.Info_actions},[_vm._t("actions")],2)]),_c('div',{class:_vm.$style.content},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }